import { render, staticRenderFns } from "./selectElevator.vue?vue&type=template&id=6f2d22de&scoped=true&"
import script from "./selectElevator.vue?vue&type=script&lang=js&"
export * from "./selectElevator.vue?vue&type=script&lang=js&"
import style0 from "./selectElevator.vue?vue&type=style&index=0&id=6f2d22de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2d22de",
  null
  
)

export default component.exports